import type { Query } from "@tanstack/react-query";

export const ONBOARDING_REQUIREMENT_QUERY_META = {
  onboardingRequirement: true,
} as const;

export const isOnboardingRequirementQuery = (query: Query): boolean =>
  query.meta?.onboardingRequirement === true;
